import { useLayout } from '@hana/shell';
import { FilesPage } from './FilesPage';
import { FilesPhone } from './FilesPhone';

/** Điện thoại dùng Mint-Files-Phone; các khổ khác giữ Mint-Files. */
export function FilesRoute() {
  return useLayout() === 'phone' ? <FilesPhone /> : <FilesPage />;
}
